// extracted by mini-css-extract-plugin
export var article = "style-module--article--8697e";
export var category = "style-module--category--37f1d";
export var date = "style-module--date--850c0";
export var details = "style-module--details--1bfad";
export var fadeIn = "style-module--fadeIn--fc5c9";
export var imageContainer = "style-module--imageContainer--b883c";
export var masked = "style-module--masked--fba9a";
export var textContainer = "style-module--textContainer--f95ca";
export var title = "style-module--title--90f06";
export var voiceContainer = "style-module--voiceContainer--46061";